import type { Span } from "../../bridge/binary";
import { useBinaryReader } from "../../bridge/binary";
import { createProxies } from "./proxies";

export interface DiagramPlayerListItem {
  id: string;
  x: number;
  y: number;
  width: number;
  height: number;
}

export interface DiagramPlayerList {
  items: DiagramPlayerListItem[];
}

interface DiagramPlayerExportsMethods {
  GetActive: () => Span<DiagramPlayerList>;
  Activate: (id: string) => Promise<void>;
  Deactivate: (id: string) => Promise<void>;
  Previous: (id: string) => Promise<void>;
  Next: (id: string) => Promise<void>;
  Reset: (id: string) => Promise<void>;
}

export interface DiagramPlayerExports {
  DiagramPlayer: DiagramPlayerExportsMethods;
}

const {
  setup,
  getActive: getActiveProxy,
  activate,
  deactivate,
  previous,
  next,
  reset,
} = createProxies<DiagramPlayerExportsMethods>([
  "GetActive",
  "Activate",
  "Deactivate",
  "Previous",
  "Next",
  "Reset",
]);

const getActive = useBinaryReader(getActiveProxy);

export {
  activate,
  deactivate,
  getActive,
  next,
  previous,
  reset,
  setup,
};
